import React from "react";
import { ArrowRight, Check } from "lucide-react";

const CoachingHero = ({ t }) => (
  <section id="top" data-testid="coaching-hero" className="relative pt-28 pb-16 md:pt-40 md:pb-24 overflow-hidden">
    <div className="absolute inset-0 bb-grid-bg opacity-40 pointer-events-none" />
    <div className="absolute -top-24 right-[-20%] w-[28rem] h-[28rem] rounded-full bg-[#1E90FF]/10 blur-[100px] pointer-events-none" />

    <div className="relative max-w-6xl mx-auto px-5 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-14 items-end">
      <div className="lg:col-span-7 bb-fade-up">
        <span className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.3em] text-[#1E90FF]">
          <span className="w-6 h-px bg-[#1E90FF]" /> {t.hero.eyebrow}
        </span>
        <h1
          data-testid="coaching-h1"
          className="mt-5 text-[2rem] leading-[1.1] sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#F3F6FA]"
        >
          {t.hero.h1}
        </h1>
        <p className="mt-5 md:mt-6 text-[#C8CED8] text-base md:text-lg leading-relaxed max-w-2xl">
          {t.hero.subtitle}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <a
            href="#request"
            data-testid="coaching-hero-cta-primary"
            className="group h-12 px-6 inline-flex items-center justify-center rounded-full bg-[#1E90FF] hover:bg-[#0066CC] text-white font-semibold transition-colors"
          >
            {t.hero.ctaPrimary}
            <ArrowRight size={18} className="ml-2 transition-transform group-hover:translate-x-1" />
          </a>
          <a
            href="#paths"
            data-testid="coaching-hero-cta-secondary"
            className="h-12 px-6 inline-flex items-center justify-center rounded-full border border-[#1E90FF]/40 text-[#F3F6FA] hover:border-[#1E90FF] hover:text-[#1E90FF] font-semibold transition-colors"
          >
            {t.hero.ctaSecondary}
          </a>
        </div>
      </div>

      <ul data-testid="coaching-hero-bullets" className="lg:col-span-5 bb-card rounded-2xl p-5 md:p-7 space-y-4">
        {t.hero.bullets.map((b) => (
          <li key={b} className="flex items-start gap-3 text-[#C8CED8] text-sm md:text-base leading-snug">
            <span className="mt-0.5 w-5 h-5 shrink-0 rounded-full bg-[#1E90FF]/15 border border-[#1E90FF]/40 flex items-center justify-center">
              <Check size={12} className="text-[#1E90FF]" />
            </span>
            {b}
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default CoachingHero;
